export const PROGRAM_TEMPLATE_NAME = 'Event';
export const EVENT_TEMPLATE_NAME = 'event';
export const EVENTSPOTLIGHT_TEMPLATE_NAME = 'eventSpotlight';
export const SPOTLIGHT_TEMPLATE_NAME = 'spotlight';
export const STARDUST_ARTICLE_TEMPLATE_NAME = 'stardustArticle';
export const BLOGUE_TEMPLATE_NAME = 'blog-ue';
